import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import type { RequestBody } from '../../../../../types/typeHelper';
import logoutSuccessEffect from '../../../../slices/auth/authThunks/logout-effect';
import { openErrorDialog } from '../../../../slices/errorDialogSlice/errorDialogSlice';
import { useApiClient } from '../../client';
import { CurrentUserQueryKeys } from '../current-user/current-user-api';

export function useLogoutMutation() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  return useMutation({
    mutationFn: () => {
      return client.GET('/auth/logout');
    },
    onSuccess: async () => {
      await queryClient.resetQueries({ queryKey: [CurrentUserQueryKeys.GET_CURRENT_USER] });
      queryClient.clear();
      dispatch(logoutSuccessEffect());
    },
  });
}

export function useTeamsLoginMutation() {
  const dispatch = useDispatch();
  const client = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ body }: { body: RequestBody<'/auth/ms-teams/login', 'post'> }) => {
      await client.POST('/auth/ms-teams/login', { body });
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [CurrentUserQueryKeys.GET_CURRENT_USER] });
    },
    onError: (error) => {
      dispatch(openErrorDialog({ dialogErrorMsg: error.message }));
    },
  });
}
